let userTableWrapper = $('#user-table-wrapper');

if(userTableWrapper.length) {
    userTableWrapper.find('.needs-js-confirm').click((e) => {
        e.preventDefault();

        confirm(userTableWrapper.data('send-login-translation'));
    })
}
